export default __webpack_public_path__ + "static/pr-newswire-8a985903c2199e41877611ef02fb0758.png";